import React from 'react';
import { 
  Card, 
  CardContent, 
  CardActions, 
  Typography, 
  Button, 
  Chip, 
  Box, 
  Avatar,
  Stack
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const WebsiteCard = ({ website }) => {
  // Determine status color
  const getStatusColor = (status) => {
    switch(status.toLowerCase()) {
      case 'operational':
        return 'success';
      case 'maintenance':
        return 'warning';
      case 'offline':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          {website.logo ? (
            <Avatar 
              src={website.logo} 
              alt={`${website.name} logo`}
              sx={{ width: 40, height: 40, mr: 1.5 }}
            />
          ) : (
            <Avatar 
              sx={{ width: 40, height: 40, mr: 1.5, bgcolor: 'primary.main' }}
            >
              {website.name.charAt(0)}
            </Avatar>
          )}
          <Typography variant="h6" component="h3" gutterBottom sx={{ mb: 0 }}>
            {website.name}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <Chip 
            icon={<FiberManualRecordIcon style={{ fontSize: 12 }} />}
            label={website.status}
            size="small"
            color={getStatusColor(website.status)}
            sx={{ height: 24 }}
          />
        </Box>
        
        <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 2 }}>
          {website.description}
        </Typography>
        
        {website.tags && website.tags.length > 0 && (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {website.tags.map(tag => (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant="outlined"
                sx={{ mb: 0.5 }}
              />
            ))}
          </Stack>
        )}
      </CardContent>
      
      <CardActions sx={{ justifyContent: 'flex-end', p: 2, pt: 0 }}>
        <Button 
          variant="contained" 
          color="primary" 
          size="medium"
          href={website.url}
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<OpenInNewIcon />}
        >
          Visit Site
        </Button>
      </CardActions>
    </Card>
  );
};

export default WebsiteCard;
